<template>
  <div>
    <base-header v-if="mySchedule.cudType =='C'" v-once pageName="일정등록" :prevBtnShow="true"></base-header>
    <base-header v-if="mySchedule.cudType =='U'" v-once pageName="일정수정" :prevBtnShow="true" :popup="true" :reload="true"></base-header>

    <section id="wrap">      
      <dl class="schedule-register">
        <dt class="req" v-if="mySchedule.scdlDivCd =='SSD06'">조직</dt>
        <dd class="search" v-if="mySchedule.scdlDivCd =='SSD06'">
          <input type="text"  v-model.trim="searchParams.searchUsername" placeholder="이름 입력 후 조회 버튼을 눌러주세요." />
          <button @click='popOrg()' type="button">조회</button>
        </dd>

        <dt class="req" v-if="!['SSD03', 'SSD06', 'SSD07'].includes(mySchedule.scdlDivCd)">고객</dt>
        <dd class="search" v-if="!['SSD03', 'SSD06', 'SSD07'].includes(mySchedule.scdlDivCd)">
          <template v-if="custNmReadOnly">
            {{mySchedule.custNm}}
          </template>
          <template v-if="!custNmReadOnly">
            <input type="text" ref="custNm" id="custNm" :value="mySchedule.custNm" v-on:input="checkText($event)" placeholder="미등록 고객의 경우 직접 입력해 주세요."/>
            <button type="button" @click='popCust'>조회</button>
          </template>
        </dd>

        <dt v-if="mySchedule.scdlDivCd =='SSD06'">{{mySchedule.username2}} &nbsp; {{mySchedule.orgnzPstnNm2}}</dt><dd></dd>
        <dt class="req">구분</dt>
        <dd class="radio">
          <!-- <template v-if="session.orgnzPstn !='COG01'"> -->
          <template>
            <span class="radioBtn">
              <input type="radio" v-model="mySchedule.scdlDivCd" id="SSD01" value="SSD01"/>
              <label for="SSD01">상담</label>
            </span>
            <span class="radioBtn">
              <input type="radio" v-model="mySchedule.scdlDivCd" id="SSD02" value="SSD02"/>
              <label for="SSD02">리크루팅</label>
            </span>
            <span class="radioBtn">
              <input type="radio" v-model="mySchedule.scdlDivCd" id="SSD03" value="SSD03"/>
              <label for="SSD03">무진활동</label>
            </span>
            <span class="radioBtn">
              <input type="radio" v-model="mySchedule.scdlDivCd" id="SSD04" value="SSD04"/>
              <label for="SSD04">A/S관리</label>
            </span>
            <span class="radioBtn">
              <input type="radio" v-model="mySchedule.scdlDivCd" id="SSD05" value="SSD05"/>
              <label for="SSD05">진단검사</label>
            </span>
          </template>
          <!-- <span class="radioBtn first" v-if="session.orgnzPstn =='COG01'">
            <input type="radio" v-model="mySchedule.scdlDivCd" id="SSD06" value="SSD06"/>
            <label for="SSD06">동행</label>
          </span> -->
          <span class="radioBtn">
            <input type="radio" v-model="mySchedule.scdlDivCd" id="SSD07" value="SSD07"/>
            <label for="SSD07">기타</label>
          </span>
          <input type="text" v-if="['SSD03', 'SSD07'].includes(mySchedule.scdlDivCd)" ref="etcCntn" id="etcCntn" :value="mySchedule.etcCntn" v-on:input="checkText($event)" :placeholder="`${etcTitle(mySchedule.scdlDivCd)} 선택 시 일정타이틀을 입력해주세요.`"/>
        </dd>
        <template v-if="(mySchedule.scdlDivCd =='SSD06' && mySchedule.allYn == 'Y')">
        <dt class="set">
          하루종일
        </dt>
        </template>
        <template v-if="mySchedule.scdlDivCd !='SSD06'">
        <dt class="set">
          종일
          <span class="set">
            <input reado type="checkbox" v-model="mySchedule.allYn" true-value="Y"  false-value="N" id="allYn"/>
            <label for="allYn"></label>
          </span>
        </dt>
        </template>
        <dd class="date">
          <dl>
            <dt>시작</dt>
            <dd>                      
              <date-pick
               v-model="mySchedule.sttDt"
               :inputAttributes="{readonly: true}"
               :startWeekOnSunday="true"
               :weekdays="['월','화','수','목','금','토','일']"
               :months="['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월']"
              ></date-pick>
              <vue-timepicker v-if="mySchedule.allYn !='Y'" v-model="mySchedule.sttHr" format="HH:mm" :minute-interval="5"></vue-timepicker>
            </dd>
            <dt>종료</dt>
            <dd>
              <date-pick
               v-model="mySchedule.endDt"
               :inputAttributes="{readonly: true}"
               :startWeekOnSunday="true"
               :weekdays="['월','화','수','목','금','토','일']"
               :months="['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월']"
              ></date-pick>
              <vue-timepicker v-if="mySchedule.allYn !='Y'" v-model="mySchedule.endHr" format="HH:mm" :minute-interval="5"></vue-timepicker>
            </dd>
          </dl>
        </dd>
        <template v-if="(mySchedule.scdlDivCd =='SSD06' && mySchedule.addr && mySchedule.addr.length > 0)">
        <dt>장소</dt>
        <dd class="location">
          <div>
            <p>
              <strong>{{mySchedule.addr}}</strong>
            </p>
            <p>              
              {{mySchedule.addrDtpt}}
            </p>
          </div>
        </dd>
        </template>
        <template v-if="mySchedule.scdlDivCd !='SSD06'">
        <dt>장소</dt>
        <dd class="location">
          <button type="button" @click='popPost'>장소검색</button>
          <div v-if="mySchedule.addr">
            <p>
              <strong>{{mySchedule.addr}}</strong>
            </p>
            <input type="text" ref="addrDtpt" id="addrDtpt" :value="mySchedule.addrDtpt" v-on:input="checkText($event)" placeholder="상세주소를 입력해주세요." />
          </div>
        </dd>
        </template>
        <dt>메모</dt>
        <dd>
          <div class="memo">
            <textarea ref="memo" id="memo" :value="mySchedule.memo" v-on:input="checkText($event)" placeholder="메모를 입력해주세요."></textarea>
            <span><em>{{memoLength}}</em>/500</span>
          </div>
        </dd>
      </dl>
    </section>
    <div class="btnWrap">
        <button v-if="mySchedule.cudType =='C'" type="button" class="red" @click="regMyschedule('C')">등록</button>
        <button v-if="mySchedule.cudType =='U'" type="button" class="red" @click="regMyschedule('U')">수정</button>
    </div>
  </div>
</template>

<script>
// import DatePick from 'vue-date-pick';
// import VueTimepicker from 'vue2-timepicker'

// () => import 'vue-date-pick/dist/vueDatePick.css';
// () => import(/* webpackChunkName: "MySchedule" */ 'vue-date-pick/dist/vueDatePick.css');
// () => import(/* webpackChunkName: "MySchedule" */ 'vue2-timepicker/dist/VueTimepicker.css');
// import 'vue2-timepicker/dist/VueTimepicker.css'
var DatePick = () => import(/* webpackChunkName: "vue-date-time" */ 'vue-date-pick');
var VueTimepicker = () => import(/* webpackChunkName: "vue-date-time" */ 'vue2-timepicker');

export default {
  name: "MyScheduleReg",
  components: {
    DatePick,
    VueTimepicker
  },
  data() {
    return {
          custNmReadOnly: false,
          memoLength: 0,
          searchParams: {
            searchUsername: ""
          },
          mySchedule: {
            cudType: 'C',
            sqno: 0,
            acmpScdlSqno: 0,
            orgAcmpScdlSqno: 0,
            userid: '',
            username2: '',
            orgnzPstnNm2: '',
            custDivCd: 'SCD02',
            custNm: '',
            scdlDivCd: '',
            etcCntn: '',
            allYn: 'N',
            sttDt: '',
            sttHr: '09:00',
            endDt: '',
            endHr: '09:00',
            addrNm: '',
            addr: '',
            addrDtpt: '',
            memo: '',
            cmplYn: '',
            dltnYn: '',
            kwkey: '',
            custsrno: ''
          },  
          session: this.$store.state.session,
          paramsSqno: -1,
    };
  },
	watch: { // 팝업창에서 선택된 값 받는 부분.
		'$store.state.ui.child'(child) {
			if(child.name == 'acmpscdlsqno-selected'){  // 일정 팝업에서 받은 일정 key값.
          console.log("MyScheduleReg.vue watch this.$store.state.ui.child.acmpScdlSqno", this.$store.state.ui.child.data.acmpScdlSqno);
        
        this.searchParams.searchUsername = "";
        this.paramsSqno = this.$store.state.ui.child.data.acmpScdlSqno;
        this.getMyschedule('A');// 팝업창에서 넘어온 키값, 동행 일정 조회일 때
			}
			if(child.name == 'juso-selected'){  // 주소검색 팝업에서 받은 값.
          // console.log("MyScheduleReg.vue watch this.$store.state.ui.child.data.bdNm", this.$store.state.ui.child.data.bdNm);
          // console.log("MyScheduleReg.vue watch this.$store.state.ui.child.data.roadAddr", this.$store.state.ui.child.data.roadAddr);
        
        this.mySchedule.addrNm = this.$store.state.ui.child.data.bdNm;
        this.mySchedule.addr = this.$store.state.ui.child.data.roadAddr;
			}
			if(child.name == 'cust-selected'){  // 고객검색 팝업에서 받은 값.
          //console.log("MyScheduleReg.vue watch this.$store.state.ui.child.data.custNm", this.$store.state.ui.child.data.custNm);
        
        this.mySchedule.custNm = this.$store.state.ui.child.data.custNm;
        this.mySchedule.custDivCd = this.$store.state.ui.child.data.custDiv;
        if(this.$store.state.ui.child.data.custDiv == "SCD01")
        {
          this.mySchedule.kwkey = this.$store.state.ui.child.data.kwkkey;
          this.mySchedule.custsrno = '';
        }
        else
        {
          this.mySchedule.kwkey = '';
          this.mySchedule.custsrno = this.$store.state.ui.child.data.kwkkey;
        }
			}
			// if(child.name == 'myorg-userid-selected'){
      //   console.log("MyScheduleReg.vue watch this.$store.state.ui.child.selectedUserid", this.$store.state.ui.child.data.selectedUserid);
                  
      //   // 조직선택 팝업에서 받은 값으로 해당 직원의 일정 조회.
      //   //var pUserid = '1563956';
      //   var pUserid = this.$store.state.ui.child.data.selectedUserid;
        
      //   //this.$router.push('/mySchedule/userScheduleList/' + pUserid);
      //   this.$utils.nativeIf.outbound.newPage('/mySchedule/userScheduleList/' + pUserid);
			// }
		}
	},
  methods: {
    params() { // 등록/수정 데이터 리턴. 날짜는 '-' 제거.
      return {
        cudType: this.mySchedule.cudType,
        sqno: this.mySchedule.sqno,
        acmpScdlSqno: this.mySchedule.acmpScdlSqno,
        orgAcmpScdlSqno: this.mySchedule.orgAcmpScdlSqno,
        userid: this.mySchedule.userid,
        custDivCd: this.mySchedule.custDivCd,
        custNm: this.mySchedule.custNm,
        scdlDivCd: this.mySchedule.scdlDivCd,
        etcCntn: this.mySchedule.etcCntn,
        allYn: this.mySchedule.allYn,
        sttDt: this.mySchedule.sttDt.replace('-','').replace('-',''),
        sttHr: this.mySchedule.sttHr.replace(':',''),
        endDt: this.mySchedule.endDt.replace('-','').replace('-',''),
        endHr: this.mySchedule.endHr.replace(':',''),
        addrNm: this.mySchedule.addrNm,
        addr: this.mySchedule.addr,
        addrDtpt: this.mySchedule.addrDtpt,
        memo: this.mySchedule.memo,
        cmplYn: this.mySchedule.cmplYn,
        dltnYn: this.mySchedule.dltnYn,
        kwkey: this.mySchedule.kwkey,
        custsrno: this.mySchedule.custsrno
      };
    },
    popOrg(){ // 조직 선택 팝업호출.
      var pUsername = this.searchParams.searchUsername;
      
      this.$utils.nativeIf.outbound.newPage('/mySchedule/orgList/' + pUsername);
    },
    popPost(){ // 주소검색 창 띄우기
      this.$utils.nativeIf.outbound.newPage('/commonPopup/postSearch/');
    },
    popCust(){ // 고객검색 창 띄우기
      this.$utils.nativeIf.outbound.newPage('/commonPopup/custSearch/');
    },
    validate() { // 유효성 체크
      if(this.mySchedule.scdlDivCd == "SSD06"){ // 구분이 동행이면
        // 일정을 선택해주세요.        
        if (this.mySchedule.acmpScdlSqno == 0) {
          alert("동행일정을 선택해주세요.");
          return false;
        }
      }
      else{
        this.mySchedule.acmpScdlSqno = 0; // 동행이 아니면 동행일정순번을 0으로 셋팅한다.

        if (!['SSD03', 'SSD07'].includes(this.mySchedule.scdlDivCd)) { // 무진활동 및 기타가 아닐 때
          if (this.$utils.stringUtil.isNull(this.mySchedule.custNm)) {
            alert("고객명을 입력해주세요.");
            this.$refs.custNm.focus();
            return false;
          }
          if(this.$utils.stringUtil.checkOverLength(this.mySchedule.custNm, 16, '고객명')){      
            this.$refs.custNm.focus();  
            return false;    
          }
        }
        if (this.$utils.stringUtil.isNull(this.mySchedule.scdlDivCd)) {
          alert("구분을 선택해주세요.");
          return false;
        }
        if (['SSD03', 'SSD07'].includes(this.mySchedule.scdlDivCd)) { // 무진활동 및 기타일 때
          let title = this.etcTitle(this.mySchedule.scdlDivCd);
          if (this.$utils.stringUtil.isNull(this.mySchedule.etcCntn)) {
            alert(`${title} 선택 시 일정타이틀을 입력해주세요.`);
            this.$refs.etcCntn.focus();
            return false;
          }
          if(this.$utils.stringUtil.checkOverLength(this.mySchedule.etcCntn, 128, `${title} 일정타이틀`)){     
            this.$refs.etcCntn.focus();
            return false;
          }
        }
        if (this.$utils.stringUtil.isNull(this.mySchedule.sttDt)) {
          alert("시작일자를 입력해주세요.");
          return false;
        }
        if (this.$utils.stringUtil.isNull(this.mySchedule.endDt)) {
          alert("종료일자를 입력해주세요.");
          return false;
        }
        if (this.mySchedule.sttDt > this.mySchedule.endDt) {
          alert("종료일이 시작일보다 과거입니다. 날짜를 확인해주세요.");
          return false;
        }
        if ("N" == this.mySchedule.allYn) { // 종일이 아니면
          if (this.$utils.stringUtil.isNull(this.mySchedule.sttHr) || this.mySchedule.sttHr.indexOf("HH") > -1 || this.mySchedule.sttHr.indexOf("mm") > -1) {
            alert("시작시간을 입력해주세요.");
            return false;
          }
          if (this.$utils.stringUtil.isNull(this.mySchedule.endHr) || this.mySchedule.endHr.indexOf("HH") > -1 || this.mySchedule.endHr.indexOf("mm") > -1) {
            alert("종료시간을 입력해주세요.");
            return false;
          }
          if (this.mySchedule.sttDt == this.mySchedule.endDt) {
            if (this.mySchedule.sttHr > this.mySchedule.endHr) {
              alert("시간을 확인해주세요.");
              return false;
            }
          }

          if(this.mySchedule.sttHr.indexOf("mm") > -1){
            this.mySchedule.sttHr = this.mySchedule.sttHr.replace("mm","00") 
          }
          if(this.mySchedule.endHr.indexOf("mm") > -1){
            this.mySchedule.endHr = this.mySchedule.endHr.replace("mm","00") 
          }
        }
        // if (this.$utils.stringUtil.isNull(this.mySchedule.addr)) {
        //   alert("주소가 선택되지 않았습니다.");
        //   this.$refs.addrDtpt.focus();
        //   return false;
        // }
        if(!this.$utils.stringUtil.isNull(this.mySchedule.addr) && this.$utils.stringUtil.checkOverLength(this.mySchedule.addr, 128, '주소')){     
          this.$refs.addrDtpt.focus();
          return false;       
        }
        // if (this.$utils.stringUtil.isNull(this.mySchedule.addrDtpt)) {
        //   alert("상세주소를 입력해주세요.");
        //   this.$refs.addrDtpt.focus();
        //   return false;
        // }
        if(!this.$utils.stringUtil.isNull(this.mySchedule.addrDtpt) && this.$utils.stringUtil.checkOverLength(this.mySchedule.addrDtpt, 64, '상세주소')){       
          this.$refs.addrDtpt.focus();
          return false;       
        }
      }
      if ( !this.$utils.stringUtil.isNull(this.mySchedule.memo) ) { // 메모에 값이 있을 때 길이 체크.
        if(this.$utils.stringUtil.checkOverLength(this.mySchedule.memo, 1024, '메모')){         
          this.$refs.memo.focus();
          return false;            
        }
      }
      return true;
    },
    getMyschedule(pType){ // 조회할 일정순번, 조회타입 A:동행, M:메인
      var that = this;

      var params = {sqno: this.paramsSqno, scdlDivCd: this.mySchedule.scdlDivCd, cudType: this.mySchedule.cudType} // 넘어온 키값
      //console.log("MyScheduleReg.vue created before getMyschedule.. params", params);

      this.$api.myschedule.getMyschedule(params)
        .then(function(res) {
          //console.log("MyScheduleReg.vue <api.myschedule.getMyschedule.response>", res.mySchedule);

          if("A" == pType){ // 동행 일정 조회일 때
            that.mySchedule.acmpScdlSqno = res.mySchedule.sqno; // 동행일정순번으로 셋팅
            that.mySchedule.username2 = res.mySchedule.username; // 동행 일정의 담당자명로 셋팅
            that.mySchedule.orgnzPstnNm2 = res.mySchedule.orgnzPstnNm; // 동행 일정의 담당자 직급으로 셋팅
            that.mySchedule.allYn = res.mySchedule.allYn;
            that.mySchedule.sttDt = res.mySchedule.sttDt;
            that.mySchedule.sttHr = res.mySchedule.sttHr;
            that.mySchedule.endDt = res.mySchedule.endDt;
            that.mySchedule.endHr = res.mySchedule.endHr;
            that.mySchedule.addrNm = res.mySchedule.addrNm;
            that.mySchedule.addr = res.mySchedule.addr;
            that.mySchedule.addrDtpt = res.mySchedule.addrDtpt;
          }else{ // 맨처음 원래 일정 조회일 때
            that.mySchedule = res.mySchedule;
            that.mySchedule.cudType = 'U'; // 수정
          }
          console.log("MyScheduleReg.vue that.mySchedule", that.mySchedule);
        })
        .catch(function(error) {
          alert(error.rtMsg); 
        });  

    },
    regMyschedule(cudType){ // 스케줄 등록/수정
      var that = this;
      var validate = this.validate();
      if(!validate) {
        return;
      }
      if(!confirm("입력한 일정을 저장하시겠습니까?")){
        return;
      }
      if (['SSD03', 'SSD07'].includes(this.mySchedule.scdlDivCd)) { // 무진활동 및 기타일 때
        this.mySchedule.custNm = '';
        this.mySchedule.kwkey = '';
        this.mySchedule.custsrno = '';
        this.mySchedule.custDivCd = '';
      }
      var params = this.params();
      
      console.log("MyScheduleReg.vue regMyschedule params", params);

      this.$api.myschedule.saveMyschedule(params)
        .then(function() {
          if(cudType == "C"){
            that.$router.push({ path: '/mySchedule/myScheduleList' }).then((() =>window.scrollTo(0,0) )); // 이동후 맨 위로 이동.;
          }else{
            that.$router.push('/mySchedule/myScheduleView/' + that.paramsSqno).then((() =>window.scrollTo(0,0) )); // 이동후 맨 위로 이동.;
            //that.$utils.nativeIf.outbound.close();
          }
        })
        .catch(function(error) {
          alert(error.rtMsg); 
        });

    },
    checkText: function(e){ // 입력 길이 체크.
        if(e.target.id == 'custNm' ){
            if(e.target.value.length > 10){
                e.target.value = e.target.value.substr(0,10);
            }else{
                this.mySchedule.custNm = e.target.value;
            }
        }
        if(e.target.id == 'etcCntn' ){
            if(e.target.value.length > 30){
                e.target.value = e.target.value.substr(0,30);
            }else{
                this.mySchedule.etcCntn = e.target.value;
            }
        }
        if(e.target.id == 'addrDtpt' ){
            if(e.target.value.length > 50){
                e.target.value = e.target.value.substr(0,50);
            }else{
                this.mySchedule.addrDtpt = e.target.value;
            }
        }
        if(e.target.id == 'memo' ){
            if(e.target.value.length > 500){
                e.target.value = e.target.value.substr(0,500);
            }else{
                this.mySchedule.memo = e.target.value;
            }
            this.memoLength = e.target.value.length;
        }
    },
    etcTitle(scdlDivCd) {
        if (scdlDivCd === 'SSD03') {
            return '무진활동';
        } else if (scdlDivCd === 'SSD07') {
            return '기타';
        }
        
        return '';
    }
  },
  mounted: function() { //  인스턴스가 마운트 된 직후
    // console.log("MyScheduleReg.vue mounted this.$route.params.sqno:"+this.$route.params.sqno);
		// console.log("MyScheduleReg.vue mounted : "+this.$store.state.session.userId);
		// console.log("MyScheduleReg.vue mounted : "+this.$store.state.session.orgnzPstn);

    // 키값이 넘어온 경우에는 상세조회한다.
    if(!this.$utils.stringUtil.isNull(this.$route.params.sqno)){
      this.paramsSqno = this.$route.params.sqno;
      this.getMyschedule('U');// 넘어온 키값, 메인 조회일 때
    }    
    else{ // 등록일 때는 기본값을 셋팅한다.
      // if("COG01" == this.$store.state.session.orgnzPstn){
      //   this.mySchedule.scdlDivCd = 'SSD06'; // 지국장일 때는 동행을 기본으로 셋팅한다.
      // }
      // else{
      //   this.mySchedule.scdlDivCd = 'SSD01'; // 그외에는 상담을 기본으로 셋팅한다.
      // }
      this.mySchedule.scdlDivCd = 'SSD01'; // 상담을 기본으로 셋팅한다.

        var today = new Date();
        var y = today.getFullYear();
        var m = today.getMonth() + 1;
        var d = today.getDate();

        var thisDay = y + '-' + this.$utils.stringUtil.pad(m) + '-' + this.$utils.stringUtil.pad(d);

        this.mySchedule.sttDt = thisDay;
        this.mySchedule.endDt = thisDay;
        
        var parent = this.$store.getters.parent;
        if(parent.name == 'cstmr-list-schedule-reg-param'){  //고객상세창이나 고객등록결과페이지에서 받은 고객이름과 고객구분 그리고, 고객번호나 교원키.
            if(parent.data.custNm && "" != parent.data.custNm)
            {
                // console.log("MyScheduleReg.vue mounted parent.data.custNm:"+parent.data.custNm);
                // console.log("MyScheduleReg.vue mounted parent.data.custDivCd:"+parent.data.custDivCd);
                this.mySchedule.custNm = parent.data.custNm;
                this.mySchedule.custDivCd = parent.data.custDivCd;
                
                if(parent.data.custDivCd == "SCD01")
                {
                  this.mySchedule.kwkey = parent.data.kwkkey;
                  this.mySchedule.custsrno = '';
                }
                else
                {
                  this.mySchedule.kwkey = '';
                  this.mySchedule.custsrno = parent.data.kwkkey;
                }
                this.custNmReadOnly = true;
            }
            // 파라메터 초기화.
            var parentReset = {
                name: 'cstmr-list-schedule-reg-param',
                data: {}
            };
            this.$store.commit("SET_UI_PARENT", parentReset);
        }
    }
  }	
};
</script>

<style>
  
</style>